import { DropDownOption } from '../interfaces/drop-down-option.interface';

export const COUPON_CALCULATION_DAYS: DropDownOption[] = [
  { id: 'BUSINESS_DAYS', displayValue: 'Business Days' },
  { id: 'CALENDAR_DAYS', displayValue: 'Calendar Days' },
];
